import EventsComponent from "../components/events/EventsComponent";

const Events: React.FC = () => {
  return (
    <>
      <EventsComponent />
    </>
  );
};
export default Events;